// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"_3wB8QAxdFud1_Xhv0POe3x"};